"use client"
import axios from "axios"
import { useEffect, useContext, useMemo, useRef, useState } from "react"
import { Link } from "react-router-dom"
import { CircuitoContext } from "../../context/CircuitoContext"
import { DomainContext } from "./LayoutCircuito" 
import { FaChevronLeft, FaChevronRight, FaCalendarAlt, FaTrophy, FaMedal } from "react-icons/fa"
import "../../styles/circuitoHomeV2.css"

export default function CircuitoHomeV2() {
  const { circuito, eventosCircuito, loadingCircuito } = useContext(CircuitoContext)
  const { basePath } = useContext(DomainContext) 

  const sliderEtapasRef = useRef(null)
  const sliderChampsRef = useRef(null)
  const getYouTubeId = (url) => {
    if (!url) return null;
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
  };
  // Estado para controlar se o comercial está rodando
  // 📼 SISTEMA DE FILA PARA COMERCIAIS
  const [filaComerciais, setFilaComerciais] = useState([]); // A lista de espera
  const [comercialAtivo, setComercialAtivo] = useState(null); // O que está tocando agora
  const [noticias, setNoticias] = useState([])
  const [loadingNoticias, setLoadingNoticias] = useState(true)
  const videoRef = useRef(null);
  const youtubeRef = useRef(null);

  const logoCircuito = circuito?.imagem ? `https://api.ticketdovaqueiro.com/uploads/${circuito.imagem}` : null

  // Filtros Globais dos Campeões
  const [categoriaCampeoes, setCategoriaCampeoes] = useState("")
  const [tipoCampeoes, setTipoCampeoes] = useState("vaqueiro")
  const [campeoes, setCampeoes] = useState([])
  const [loadingCampeoes, setLoadingCampeoes] = useState(false)
  const [patrocinadores, setPatrocinadores] = useState([])
  const [etapasManuais, setEtapasManuais] = useState([])
  
  // 💡 ESTADO PARA CONTROLAR QUAL CARTA ESTÁ VIRADA (FLIPPED)
  const [flippedCardId, setFlippedCardId] = useState(null)

  const isCustomDomain = window.location.hostname !== "ticketdovaqueiro.com" && window.location.hostname !== "www.ticketdovaqueiro.com" && window.location.hostname !== "localhost";

  // Preenche a primeira categoria automaticamente
  useEffect(() => {
    if (circuito?.categorias?.length > 0 && !categoriaCampeoes) {
      setCategoriaCampeoes(circuito.categorias[0].nome || circuito.categorias[0])
    }
  }, [circuito])

  useEffect(() => {
    if (!circuito?._id) return
    axios.get(`https://api.ticketdovaqueiro.com/api/circuitos/${circuito._id}/etapas-manuais`)
      .then((res) => setEtapasManuais(res.data || [])).catch(() => setEtapasManuais([]))
  }, [circuito?._id])
// 🎬 DIRETOR DE TV: Agenda os vídeos. Cada comercial roda no seu próprio tempo,
  // mas em vez de tocar direto, ele joga o vídeo na "fila de reprodução".
  useEffect(() => {
    if (!circuito?.comerciais || circuito.comerciais.length === 0) return;

    const timers = circuito.comerciais.map(comercial => {
      if (comercial.intervaloMinutos > 0 && comercial.video) {
        return setInterval(() => {
          // Quando der o tempo, coloca o vídeo no final da fila
          setFilaComerciais(prev => [...prev, comercial.video]);
        }, comercial.intervaloMinutos * 60 * 1000);
      }
      return null;
    });

    return () => timers.forEach(timer => timer && clearInterval(timer));
  }, [circuito]);

  // 🎛️ OPERADOR DE MESA: Puxa da fila e garante o Play no celular
  useEffect(() => {
    if (!comercialAtivo && filaComerciais.length > 0) {
      setComercialAtivo(filaComerciais[0]);
      setFilaComerciais(prev => prev.slice(1));
    }
  }, [filaComerciais, comercialAtivo]);

  // 🚀 ANTI-TRAVAMENTO: Força o play suave quando o comercial entra
  // 🚀 CONTROLE DE ÁUDIO E ANTI-TRAVAMENTO (PC E CELULAR)
  useEffect(() => {
    if (comercialAtivo && videoRef.current) {
      
      // 1. SILENCIA A TRANSMISSÃO DO YOUTUBE IMEDIATAMENTE
      if (youtubeRef.current && youtubeRef.current.contentWindow) {
        youtubeRef.current.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'mute', args: [] }), '*');
      }

      // 2. PREPARA O COMERCIAL
      videoRef.current.currentTime = 0; // Volta para o segundo zero sem engasgar a rede do PC
      videoRef.current.muted = false;   // Tenta tocar com som primeiro!

      // 3. TENTA DAR O PLAY
      const playPromise = videoRef.current.play();
      
      if (playPromise !== undefined) {
        playPromise.catch(error => {
          console.warn("Navegador bloqueou o áudio automático. Rodando no mudo...", error);
          
          // Fallback obrigatório: Se o celular/PC bloquear o som, toca mudo para não travar.
          videoRef.current.muted = true; 
          videoRef.current.play().catch(fatalError => {
            console.error("Erro fatal ao carregar vídeo. Cancelando comercial...", fatalError);
            // TRAVA DE SEGURANÇA: Se der erro (ex: internet caiu), ele fecha a tela preta e volta pro YouTube
            finalizarComercial(); 
          });
        });
      }
    }
  }, [comercialAtivo]);

  // 🔄 ACORDA O YOUTUBE: Função que roda quando o comercial acaba
  // 🔄 FINALIZA COMERCIAL E VOLTA O YOUTUBE
  const finalizarComercial = () => {
    setComercialAtivo(null);
    if (youtubeRef.current && youtubeRef.current.contentWindow) {
      // 1. Tira o mudo da transmissão (unMute) e garante o play (playVideo)
      youtubeRef.current.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'unMute', args: [] }), '*');
      youtubeRef.current.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'playVideo', args: [] }), '*');
    }
  };
  const etapasUnificadas = useMemo(() => {
    const internas = (eventosCircuito || []).map((e, index) => ({
      id: e._id, nome: e.nome, imagem: e.imagem, dataInicio: e.dataInicio, dataFim: e.dataFim, tipo: "interna", 
      link: isCustomDomain ? `https://ticketdovaqueiro.com/evento/${e._id}` : `/evento/${e._id}`, ordem: index + 1,
    }))
    const manuais = (etapasManuais || []).map((e) => ({
      id: e._id, nome: e.nome, imagem: e.imagemCartaz, dataInicio: e.dataInicioVendas, dataFim: e.dataFimVendas, tipo: "externa", link: e.linkExterno, ordem: 999,
    }))
    return [...internas, ...manuais].sort((a, b) => new Date(a.dataInicio) - new Date(b.dataInicio))
  }, [eventosCircuito, etapasManuais, isCustomDomain])

  // Busca dos Campeões baseada em Categoria e Tipo
  useEffect(() => {
    const carregarCampeoes = async () => {
      try {
        if (!circuito?._id || !categoriaCampeoes) return
        setLoadingCampeoes(true)
        const res = await axios.get(`https://api.ticketdovaqueiro.com/api/circuitos/${circuito._id}/campeoes?categoria=${categoriaCampeoes}&tipo=${tipoCampeoes}`)
        setCampeoes(res.data || [])
      } catch (e) {
        setCampeoes([])
      } finally {
        setLoadingCampeoes(false)
      }
    }
    carregarCampeoes()
  }, [circuito?._id, categoriaCampeoes, tipoCampeoes])

  const scrollEtapas = (dir) => { if (sliderEtapasRef.current) sliderEtapasRef.current.scrollBy({ left: dir * 320, behavior: "smooth" }) }
  const scrollChamps = (dir) => { if (sliderChampsRef.current) sliderChampsRef.current.scrollBy({ left: dir * 320, behavior: "smooth" }) }
  const formatarDataSimples = (dataString) => { if (!dataString) return "-"; return new Date(dataString).toLocaleDateString("pt-BR") }

  useEffect(() => {
    const carregarDados = async () => {
      try {
        if (!circuito?._id) return
        setLoadingNoticias(true)
        const [resNoticias, resPatrocinadores] = await Promise.all([
          axios.get(`https://api.ticketdovaqueiro.com/api/circuitos/${circuito._id}/noticias`),
          axios.get(`https://api.ticketdovaqueiro.com/api/circuitos/${circuito._id}/patrocinadores`)
        ]);
        setNoticias(resNoticias.data || [])
        setPatrocinadores(resPatrocinadores.data || [])
      } finally { setLoadingNoticias(false) }
    }
    carregarDados()
  }, [circuito?._id])

  const tiposCampeoesList = [
    { value: "vaqueiro", label: "Vaqueiro" },
    { value: "esteireiro", label: "Esteireiro" },
    { value: "cavaloPuxada", label: "Cavalo de Puxar" },
    { value: "cavaloEsteira", label: "Cavalo de Esteira" },
  ]

  const toggleFlip = (id) => {
     if (flippedCardId === id) setFlippedCardId(null)
     else setFlippedCardId(id)
  }

  return (
    <div className="ch-page">
      {/* 💡 CSS INJETADO EXCLUSIVO PARA O FLIP DAS CARTAS */}
      <style dangerouslySetInnerHTML={{__html: `
        .scene-flip {
          perspective: 1000px;
          cursor: pointer;
          min-width: 300px;
          height: 480px;
          margin-right: 20px;
          flex-shrink: 0;
        }
        .card-flip-inner {
          position: relative;
          width: 100%;
          height: 100%;
          transition: transform 0.6s cubic-bezier(0.4, 0.2, 0.2, 1);
          transform-style: preserve-3d;
        }
        .card-flip-inner.is-flipped { transform: rotateY(180deg); }
        .card-face-front, .card-face-back {
          position: absolute;
          width: 100%;
          height: 100%;
          backface-visibility: hidden;
          border-radius: 12px;
          overflow: hidden;
          background: var(--c-card);
          border: 1px solid rgba(255,255,255,0.05);
          box-shadow: 0 10px 30px rgba(0,0,0,0.5);
          display: flex;
          flex-direction: column;
        }
        .card-face-back {
          transform: rotateY(180deg);
          background: #111;
          padding: 20px;
        }
        .hist-list { overflow-y: auto; flex: 1; padding-right: 5px; }
        .hist-list::-webkit-scrollbar { width: 4px; }
        .hist-list::-webkit-scrollbar-thumb { background: var(--c-accent); border-radius: 4px; }
        .hist-item { background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.05); padding: 12px; border-radius: 8px; margin-bottom: 12px; }
        .hist-res { display: flex; justify-content: space-between; margin-top: 8px; padding: 6px 10px; background: rgba(0,0,0,0.4); border-radius: 4px; font-size: 13px; font-weight: bold; }
        .hist-res span:last-child { color: var(--c-accent); }
      `}} />

      <section className="ch-hero">
        <div className="ch-hero__bg" />
        <div className="ch-hero__content">
          {logoCircuito && <img src={logoCircuito} alt={circuito?.nome} className="ch-hero__logo" />}
          <h1 className="ch-hero__title">{circuito?.nome || "Circuito"}</h1>
          <p className="ch-hero__subtitle">{circuito?.descricao || "O melhor circuito de vaquejada da região"}</p>
          <div className="ch-hero__actions">
            <Link to={`${basePath}/inscrever-se`} className="ch-btn ch-btn--primary">Associe-se agora</Link>
            <Link to={`${basePath}/ranking`} className="ch-btn ch-btn--outline">Ver Ranking</Link>
          </div>
        </div>
      </section>

      <section className="ch-section">
        <div className="ch-container">
          <div className="ch-section__header">
            <h2 className="ch-section__title"><FaCalendarAlt className="ch-section__icon" /> Últimas Notícias</h2>
            <Link to={`${basePath}/noticias`} className="ch-section__link">Ver todas</Link>
          </div>

          {loadingNoticias ? (
            <div className="ch-loading">Carregando notícias...</div>
          ) : noticias.length === 0 ? (
            <div className="ch-empty">Nenhuma notícia publicada ainda.</div>
          ) : (
            <div className="ch-news-grid">
              <Link to={`${basePath}/noticias/${noticias[0]._id}`} className="ch-news-card ch-news-card--featured">
                <div className="ch-news-card__image"><img src={noticias[0].imagem ? `https://api.ticketdovaqueiro.com/uploads/${noticias[0].imagem}` : "https://via.placeholder.com/900x500"} alt="" /></div>
                <div className="ch-news-card__content">
                  <h3 className="ch-news-card__title">{noticias[0].titulo}</h3>
                  <p className="ch-news-card__excerpt">Ler matéria &rarr;</p>
                </div>
              </Link>
              <div className="ch-news-secondary">
                {noticias.slice(1, 3).map((n) => (
                  <Link key={n._id} to={`${basePath}/noticias/${n._id}`} className="ch-news-card ch-news-card--small">
                    <div className="ch-news-card__image"><img src={n.imagem ? `https://api.ticketdovaqueiro.com/uploads/${n.imagem}` : "https://via.placeholder.com/600x400"} alt="" /></div>
                    <div className="ch-news-card__content"><h4 className="ch-news-card__title">{n.titulo}</h4></div>
                  </Link>
                ))}
              </div>
            </div>
          )}
        </div>
      </section>
      {/* 📺 SEÇÃO TV AO VIVO */}
      {circuito?.linkTvAoVivo && getYouTubeId(circuito.linkTvAoVivo) && (
        <section className="tv-ao-vivo-section">
          <div className="ch-container">
            <div className="tv-container-player">
              
              {/* Vídeo do YouTube */}
              <div className="tv-iframe-wrapper">
                <div className="tv-selo-aovivo">
                  <div className="tv-selo-bolinha"></div> AO VIVO
                </div>
                
                {/* 💡 YOUTUBE COM enablejsapi=1 PARA PODERMOS DAR PLAY DEPOIS */}
                <iframe
                  ref={youtubeRef}
                  src={`https://www.youtube.com/embed/${getYouTubeId(circuito.linkTvAoVivo)}?autoplay=1&mute=1&rel=0&enablejsapi=1`}
                  title="TV AO VIVO"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>

                {/* 📼 CORTINA DO COMERCIAL (SEMPRE NO DOM PARA NÃO TRAVAR O CELULAR) */}
                <video
                  ref={videoRef}
                  src={comercialAtivo ? `https://api.ticketdovaqueiro.com/uploads/${comercialAtivo}` : ""}
                  playsInline
                  preload="auto"
                  style={{
                    position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
                    zIndex: comercialAtivo ? 20 : -1, /* Fica atrás quando inativo */
                    opacity: comercialAtivo ? 1 : 0,  /* Fade in/out suave */
                    pointerEvents: comercialAtivo ? 'auto' : 'none',
                    objectFit: 'cover', background: '#000',
                    transition: 'opacity 0.4s ease-in-out' /* Tira o efeito de piscar */
                  }}
                  onEnded={finalizarComercial} 
                />
              </div>

              {/* Letreiro Dinâmico: Mistura Texto + Imagens dos Patrocinadores */}
              {(circuito?.textoAvisoTv || patrocinadores?.length > 0) && (
                <div className="tv-rodape-marquee">
                  <div className="tv-ticker-track">
                    {/* Bloco 1 */}
                    <div className="tv-ticker-content">
                      {circuito?.textoAvisoTv && <span className="tv-aviso-texto">⚠️ {circuito.textoAvisoTv}</span>}
                      {patrocinadores?.map((pat, index) => (
                        <img key={`pat1-${index}`} src={`https://api.ticketdovaqueiro.com/uploads/${pat.imagem}`} alt="Patrocinador" className="tv-sponsor-logo" />
                      ))}
                    </div>
                    {/* Bloco 2 (Duplicado para criar o efeito de Loop Infinito sem cortes) */}
                    <div className="tv-ticker-content">
                      {circuito?.textoAvisoTv && <span className="tv-aviso-texto">⚠️ {circuito.textoAvisoTv}</span>}
                      {patrocinadores?.map((pat, index) => (
                        <img key={`pat2-${index}`} src={`https://api.ticketdovaqueiro.com/uploads/${pat.imagem}`} alt="Patrocinador" className="tv-sponsor-logo" />
                      ))}
                    </div>
                  </div>
                </div>
              )}

            </div>
          </div>
        </section>
      )}
      {patrocinadores.length > 0 && (
        <section className="ch-section" style={{ paddingTop: 0 }}>
          <div className="ch-container">
            <div className="ch-sponsors-grid">
              {patrocinadores.map((p) => (
                <a key={p._id} href={p.linkExterno || "#!"} target={p.linkExterno ? "_blank" : "_self"} rel="noreferrer" className="ch-sponsor-banner">
                  <img src={`https://api.ticketdovaqueiro.com/uploads/${p.imagem}`} alt={p.nome} />
                </a>
              ))}
            </div>
          </div>
        </section>
      )}

      <section className="ch-section ch-section--alt">
        <div className="ch-container">
          <div className="ch-section__header">
            <h2 className="ch-section__title"><FaTrophy className="ch-section__icon" /> Hall da Fama</h2>
            <p style={{color: "rgba(255,255,255,0.6)", fontSize: 14, margin: "8px 0 0 0"}}>Clique nas cartas para ver o histórico de etapas</p>
          </div>

          <div className="ch-champions">
            <div className="ch-champions__filters" style={{ gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 30 }}>
              <div className="ch-form-group">
                <label className="ch-label">Categoria do Circuito</label>
                <select className="ch-select" value={categoriaCampeoes} onChange={(e) => setCategoriaCampeoes(e.target.value)}>
                  {circuito?.categorias?.map((c, idx) => {
                     const catName = c.nome || c;
                     return <option key={idx} value={catName}>{catName}</option>
                  })}
                </select>
              </div>
              <div className="ch-form-group">
                <label className="ch-label">Tipo de Competidor</label>
                <select className="ch-select" value={tipoCampeoes} onChange={(e) => setTipoCampeoes(e.target.value)}>
                  {tiposCampeoesList.map((t) => <option key={t.value} value={t.value}>{t.label}</option>)}
                </select>
              </div>
            </div>

            <div className="ch-champions__list">
              {loadingCampeoes ? (
                <div className="ch-loading">Carregando estrelas do ranking...</div>
              ) : campeoes.length === 0 ? (
                <div className="ch-empty">Nenhum campeão cadastrado para este filtro no momento.</div>
              ) : (
                <div className="ch-slider" style={{ padding: "20px 0" }}>
                  <button className="ch-slider__arrow ch-slider__arrow--left" onClick={() => scrollChamps(-1)}><FaChevronLeft /></button>
                  
                  <div className="ch-slider__track" ref={sliderChampsRef} style={{ display: "flex", overflowX: "auto", scrollSnapType: "x mandatory", paddingBottom: 20 }}>
                    {campeoes.map((c) => {
  const isFlipped = flippedCardId === c._id;

  return (
    <div className="scene-flip" key={c._id} onClick={() => toggleFlip(c._id)}>
      <div className={`card-flip-inner ${isFlipped ? "is-flipped" : ""}`}>
        
        {/* FRENTE DO CARD */}
        <div className="card-face-front">
          <div className="ch-badge-posicao">{c.posicao}º Lugar</div>
          
          <div className="ch-card-img-wrapper">
            <img 
              src={c.foto ? `https://api.ticketdovaqueiro.com/uploads/${c.foto}` : "https://via.placeholder.com/400x500"} 
              alt={c.nome} 
            />
          </div>

          <div className="ch-card-info-clean">
            <h3 className="ch-card-name-v2">{c.nome}</h3>
            
            <div className="ch-card-score-v2">
              <span className="pts-val">{c.pontos}</span>
              <span className="pts-lbl">Pontos Totais</span>
            </div>

            <span style={{ fontSize: '9px', color: '#555', marginTop: '5px' }}>
                CLIQUE PARA DETALHES ↻
            </span>
          </div>
        </div>

        {/* VERSO DO CARD (HISTÓRICO) */}
<div className="card-face-back">
  <div className="hist-header-v2" style={{ textAlign: 'center', marginBottom: '5px' }}>
    <h3 style={{ fontSize: '14px', color: '#fff', textTransform: 'uppercase', letterSpacing: '1px' }}>
      Histórico de Etapas
    </h3>
  </div>

  <div className="hist-list-v2">
    {c.historico && c.historico.length > 0 ? (
      c.historico.map((etapa, idx) => {
        // Soma os pontos de todas as colocações desta etapa
        const totalPontosEtapa = etapa.resultados?.reduce((acc, res) => acc + (Number(res.pontos) || 0), 0) || 0;

        return (
          <div key={idx} className="hist-item-v2">
            {/* Linha Principal: Nome da Etapa e Total de Pontos */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
              <span style={{ fontSize: '11px', fontWeight: '800', color: '#fff', textTransform: 'uppercase', maxWidth: '70%' }}>
                {etapa.nomeEtapa}
              </span>
              <span style={{ fontSize: '12px', fontWeight: '900', color: '#fff' }}>
                {totalPontosEtapa} <small style={{ fontSize: '8px', opacity: 0.6 }}>PTS</small>
              </span>
            </div>

            {/* Sub-lista: Todas as colocações que ele ganhou nesta etapa */}
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
              {etapa.resultados?.map((res, resIdx) => (
                <div key={resIdx} style={{ 
                  background: 'rgba(255,255,255,0.1)', 
                  padding: '3px 8px', 
                  borderRadius: '6px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px'
                }}>
                  <span style={{ fontSize: '10px', fontWeight: 'bold', color: '#fff' }}>{res.posicao}</span>
                  <span style={{ fontSize: '9px', color: 'rgba(255,255,255,0.6)' }}>({res.pontos} pts)</span>
                </div>
              ))}
            </div>
          </div>
        );
      })
    ) : (
      <div style={{ textAlign: "center", color: "#666", marginTop: 40, fontSize: '12px' }}>
        Nenhum histórico registrado.
      </div>
    )}
  </div>

  {/* Botão de Voltar fixo no rodapé do verso */}
  <button 
    onClick={(e) => { e.stopPropagation(); toggleFlip(c._id); }}
    style={{
      marginTop: '10px',
      background: 'transparent',
      border: '1px solid rgba(255,255,255,0.2)',
      color: '#888',
      fontSize: '10px',
      padding: '8px',
      borderRadius: '20px',
      width: '100%',
      cursor: 'pointer'
    }}
  >
    VOLTAR ↺
  </button>
</div>

      </div>
    </div>
  )
})}
                  </div>

                  <button className="ch-slider__arrow ch-slider__arrow--right" onClick={() => scrollChamps(1)}><FaChevronRight /></button>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      <footer className="ch-footer">
        <div className="ch-container">
          <p>Desenvolvido por <a href="https://wa.me/5513991503946" target="_blank" rel="noopener noreferrer" style={{ color: "inherit", textDecoration: "none", fontWeight: "bold" }}>Ticket do Vaqueiro</a></p>
        </div>
      </footer>
    </div>
  )
}